import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import PrivateRoute from "./route/PrivateRoute";
import { RedirectAs404 } from "./utils/Utils";

import { ToastContainer } from "react-toastify";
import { RecoilRoot } from "recoil";
import "./assets/scss/theme.scss";
import { Loading } from './components/Component';
import { ModalContainer, ModalProvider } from "./context/modal";
import { UserProvider } from "./context/user";
import Layout from "./layout/Index";
import Login from "./pages/auth/Login";


const App = () => {
  return (
    <RecoilRoot>
      <UserProvider>
        <ModalProvider>
          <Switch>
            <Route exact path={`/login`} component={Login}></Route>
            <PrivateRoute exact path="" component={Layout}></PrivateRoute>
            <Route component={RedirectAs404}></Route>
          </Switch>
          <ToastContainer />
          <ModalContainer />
          <Loading />
        </ModalProvider>
      </UserProvider>
    </RecoilRoot>
  );
};
export default withRouter(App);
